import { GroupContext } from "@Totum/Main/Constants";
import useCurrentGroupId from "@Totum/Groups/State/hooks/useCurrentGroupId";
import { useDeleteGroup } from "@Totum/Groups/State/mutations";
import { useGroupCreditsQuery, useUserGroupQuery, useUserGroupsQuery } from "@Totum/Groups/State/queries";
import { hasCapability } from "@Totum/Main/Utils";

/**
 * Orchestrates the operations for the `Search List` component.
 */
const useGroupsListOperations = () => {
    // ** Constants & Variables ** //
    const [currentGroupId] = useCurrentGroupId();
    // ** Hooks ** //
    const { data: userGroupsMinimal, ...otherUserGroupsQueryProps } = useUserGroupsQuery();
    const { data: userGroup, ...otherUserGroupQueryProps } = useUserGroupQuery(currentGroupId);
    const { data: groupCredits } = useGroupCreditsQuery(currentGroupId);
    const deleteGroupMutation = useDeleteGroup();

    // ** Functions ** //
    const deleteGroup = (groupId?: string) => {
        deleteGroupMutation.mutateAsync(groupId);
    };

    // ** Constants & Variables ** //
    const userGroups = userGroupsMinimal?.isSuccess
        ? userGroupsMinimal.value.subGroups.filter((group) =>
              hasCapability("UserGroup/Get", GroupContext, group.groupId)
          )
        : [];

    const userGroupIndividual = userGroup?.isSuccess ? userGroup.value.subGroups : [];

    // ** Exports ** //

    return {
        // data
        userGroups,
        userGroup: userGroupIndividual,
        groupCredits,

        //methods
        deleteGroup,

        // state
        isFetchingUserGroups: otherUserGroupsQueryProps.isFetching,
        isFetchingUserGroup: otherUserGroupQueryProps.isFetching,
    };
};

export default useGroupsListOperations;
